import { cloneDeep } from 'lodash-es'

import { Content } from '@lyrahealth-inc/shared-app-logic/src/models/assignments/Assignments'

import { BodyTextSize } from '../../styles/typeStyles'

/**
 * Adds a Lyra Select Client notice to a note's metadata and UI schema
 * @param note - The original note content to be modified
 * @param afterField - Optional field name to place the notice after. If not provided or field not found, notice will be placed at the beginning
 * @returns A new note object with the Lyra Select Client notice added
 * @example
 * // Place at beginning
 * const note1 = addLyraSelectClientNoticeToNote(originalNote)
 *
 * // Place after specific field
 * const note2 = addLyraSelectClientNoticeToNote(originalNote, 'clientInfo')
 */
export const addLyraSelectClientNoticeToNote = (note: Content, afterField?: string): Content => {
  const updatedNote = cloneDeep(note)
  // Add the lyraSelectClientNotice to the schema
  if (updatedNote.meta_data?.schema?.properties) {
    updatedNote.meta_data.schema.properties.lyraSelectClientNotice = {
      name: 'lyraSelectClientNotice',
      type: 'string',
    }
  }

  // Add the lyraSelectClientNotice to the UI schema
  if (updatedNote.meta_data?.uiSchema) {
    if (Array.isArray(updatedNote.meta_data.uiSchema['ui:order'])) {
      const fieldIndex = afterField !== undefined ? updatedNote.meta_data.uiSchema['ui:order'].indexOf(afterField) : -1
      if (fieldIndex !== -1) {
        updatedNote.meta_data.uiSchema['ui:order'].splice(fieldIndex + 1, 0, 'lyraSelectClientNotice')
      } else {
        updatedNote.meta_data.uiSchema['ui:order'].unshift('lyraSelectClientNotice')
      }
    }

    updatedNote.meta_data.uiSchema.lyraSelectClientNotice = {
      'ui:widget': 'inlineWarningBanner',
      'ui:options': {
        title: 'Lyra Select Member',
        bannerMessage:
          'Your client can use EAP sessions for coaching and therapy programs only. Select clients are not eligible for expansion services (e.g. DBT, Renew, CFP, LCT-Teens, Medication Management, Leave Evaluations) or continuation of care with Lyra.',
        textSize: BodyTextSize.SMALL,
      },
    }
  }

  return updatedNote
}
